import React from "react";
import { Button, theme } from "antd";
import { ShareAltOutlined, DownloadOutlined } from "@ant-design/icons";
import styles from "./styles/QurealCanvas.module.css";
import LanguageDD from "./customizers/LanguageDD";
import { AutoApplyTheme } from "./DesignCustomization";

function CanvasBar({
    lang,
    setLang,
    isTranslating,
    prefill,
    setPrefill,
    gs_overrides,
    setGSOverrides,
    me,
    item,
    isMobile,
    share,
    download,
    status,
}) {
    const { token } = theme.useToken();
    return (
        <div
            className={styles.canvas_bar}
            style={{
                backgroundColor: token.colorBgContainer,
                borderBottom: `1px solid ${token.colorBorderSecondary}`,
            }}
        >
            <div className={styles.canvas_bar_left}>
                <LanguageDD
                    value={lang}
                    onChange={(val) => setLang(val)}
                    loading={isTranslating}
                    minimal={true}
                    width={200}
                />
                <AutoApplyTheme
                    prefill={prefill}
                    setPrefill={setPrefill}
                    gs_overrides={gs_overrides}
                    setGSOverrides={setGSOverrides}
                    color_palettes={me?.selected_org?.color_palettes || []}
                    fixed_logo_theme={item?.fixed_logo_theme}
                    design_theme={item?.theme}
                    org={me?.selected_org}
                    isMobile={isMobile}
                />
            </div>
            <div className={styles.canvas_bar_actions}>
                <div className={styles.canvas_bar_inside}>
                    <Button
                        onClick={share}
                        loading={status?.share}
                        icon={<ShareAltOutlined />}
                    />
                    <Button
                        onClick={download}
                        loading={status?.download}
                        icon={<DownloadOutlined />}
                        type="primary"
                    >
                        {isMobile ? "" : "Download"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default CanvasBar;
